import { render, staticRenderFns } from "./StaticImage.vue?vue&type=template&id=18439c0b&scoped=true&"
import script from "./StaticImage.vue?vue&type=script&lang=js&"
export * from "./StaticImage.vue?vue&type=script&lang=js&"
import style0 from "./StaticImage.vue?vue&type=style&index=0&id=18439c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18439c0b",
  null
  
)

export default component.exports